import { useHandlers } from '../../../context/page-context';
import type { CustomerGroupsApiContract } from '../api';

export function useCustomerGroupsApi(): { customerGroupsApi: CustomerGroupsApiContract } {
  const { apis } = useHandlers();
  return { customerGroupsApi: apis.customerGroups };
}
